import { render, staticRenderFns } from "./cityBroadcast.vue?vue&type=template&id=52ed4ade"
import script from "./cityBroadcast.vue?vue&type=script&lang=js"
export * from "./cityBroadcast.vue?vue&type=script&lang=js"
import style0 from "./cityBroadcast.vue?vue&type=style&index=0&id=52ed4ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports